{
  "version": 1,
  "asset_id": "c29fa7e4-53c8-4b03-b15e-403da619d986",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/c29fa7e4-53c8-4b03-b15e-403da619d986/ind-automotive-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/c29fa7e4-53c8-4b03-b15e-403da619d986/ind-automotive-640.avif",
  "original_filename": "ind-automotive-640.avif",
  "size": 10169,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:55Z"
}
